import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import AuthService from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        console.log("🔐 Checking Amplify Session in Callback");
        const session = await AuthService.getSession();

        if (session) {
          console.log("✅ Valid session found, redirecting to dashboard");
          navigate("/dashboard");
          return;
        }

        // If no session, wait a bit or redirect to login
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        if (code) {
          // Future: Handle OAuth code exchange if needed via Amplify
          console.log("🔑 OAuth code detected, Amplify should handle this automatically via Hub");
        }

        // Default redirect
        setTimeout(() => navigate("/login"), 3000);

      } catch (err: any) {
        console.error("❌ Auth Callback Error:", err);
        setError(err.message || "Authentication failed");
      }
    };

    handleAuthCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted px-4">
        <Card className="w-full max-w-md p-6">
          <CardContent className="text-center space-y-4">
            <div className="mx-auto w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
              <AlertCircle className="h-6 w-6 text-red-600" />
            </div>
            <h2 className="text-xl font-semibold">Authentication Error</h2>
            <p className="text-muted-foreground">{error}</p>
            <div className="space-y-2 pt-4">
              <Button onClick={() => navigate("/login")} className="w-full bg-[#12BB81] hover:bg-[#0fa371]">
                Back to Login
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      <Card className="p-6">
        <CardContent className="text-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin mx-auto text-[#12BB81]" />
          <p className="text-muted-foreground">Verifying your link...</p>
        </CardContent>
      </Card>
    </div>
  );
}
